'use client';

import { useApiClient } from '../../../../contexts/ApiContext';
import { SetRushMidWeaponSkinRequestWeaponKeyEnum } from '../../../../services/generated/Api';

/** Persist a weapon-skin pick per weapon key. `null` goes back to the stock weapon. The match
 *  reads the selection from the DB and re-checks access there, so nothing is transported on
 *  enter. Fire-and-forget, same as the fighter-skin pick. */
export function useWeaponSkinPersist(): (weaponKey: SetRushMidWeaponSkinRequestWeaponKeyEnum, skin: string | null) => void {
  const apiClient = useApiClient();
  return (weaponKey, skin) => {
    apiClient.api.rushMidControllerSetWeaponSkin({ weaponKey, skin }).catch(() => {});
  };
}
